import { ssoApi } from "@sso/apis";
import { ApiMethodKeys, notificationsMsgs, SnackbarKeys } from "@sso/constant";
import { pushSnackbar } from "@sso/store/slices/snackbar";
import { ProductByApiAccount, ProductToggleApiAccountRoleRequest } from "@sso/types";

import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

export const apiAccountProductsApi = ssoApi
  .enhanceEndpoints({
    addTagTypes: [CacheKeys.API_ACCOUNTS, CacheKeys.API_ACCOUNT_PRODUCTS],
  })
  .injectEndpoints({
    endpoints: builder => ({
      productAccessByApiAccount: builder.query<ProductByApiAccount[], string>({
        query: apiAccountId => ({
          url: `${Endpoints.API_ACCOUNT_PRODUCTS}/AccessibleByApiAccount`,
          params: { apiAccountId },
        }),
        transformResponse: (response: { result: ProductByApiAccount[] }) => response.result,
        providesTags: [CacheKeys.API_ACCOUNT_PRODUCTS],
      }),
      toggleApiAccountProductRole: builder.mutation<void, ProductToggleApiAccountRoleRequest>({
        query: data => ({ url: `${Endpoints.API_ACCOUNT_PRODUCTS}/ToggleRole`, method: ApiMethodKeys.POST, data }),
        invalidatesTags: [CacheKeys.API_ACCOUNTS],
        onQueryStarted(request, { dispatch, queryFulfilled }) {
          queryFulfilled.then(() => {
            dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.API_ACCOUNT_ROLES_UPDATED }));
            dispatch(
              apiAccountProductsApi.util.updateQueryData("productAccessByApiAccount", request.apiAccountId, draft => {
                return draft.map(product => {
                  if (product.softwareId === request.softwareId) {
                    const roles = product.assignedRoles.includes(request.roleId)
                      ? product.assignedRoles.filter(r => r !== request.roleId)
                      : product.assignedRoles.concat([request.roleId]);

                    return { ...product, assignedRoles: roles };
                  }
                  return { ...product };
                });
              }),
            );
          });
        },
      }),
    }),
  });

export const { useProductAccessByApiAccountQuery, useToggleApiAccountProductRoleMutation } = apiAccountProductsApi;
